<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    import Login from "./login.svelte";
    import Header from "../components/header.svelte"
    import { isUserDbAdmin} from './stores.js';

    export var db;
    export var auth;
    export let location;
    location = location;

    var user = auth.currentUser;
    var is_Admin =false;
    
    function goLogin() {
      navigate("/login", { replace: false });
  }

  function goRegister() {
      navigate("/register", { replace: false });
  }

  function scrollProp() {
  window.scrollY(500);
  
}

function scrollContact() {
  window.scrollY(1000);
}

var storedUser;

const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});

if(user){
    if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
              } else {
                  isUserDbAdmin.set({admin:false})
              }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }
    if(storedUser.admin == true){
         is_Admin = true
       }
}

function logout(){
    console.log('deconnexion demander')
  auth.signOut().then(() => {
      console.log(user)
    user = undefined;
    console.log(user)
    window.location.reload()
}).catch((error) => {
  // An error happened.
});
}

</script>


<main>
    <Header class="header">
        {#if user !=undefined}
        <div on:click={logout} class="elm">Déconnexion</div>
        <a href="/user" use:link >Ma Liste 📃</a>
        <a href="/user" use:link >RDV ⏰</a> 
        {#if is_Admin}
        <a href="/jouets" use:link >Articles 🧸</a> 
        <a href="/clients" use:link >Vendeurs 👱‍♂️</a> 
        <a href="/panier" use:link >Panier 🛒</a> 
        {/if}
        {:else}
        <a href="/login" use:link >Se connecter</a> 
        {/if}
        <a href="#propos" on:click={scrollProp} >A propos</a> 
        <a href="#contact" >Contact</a>
    </Header>
    
    
    <div class="main" >
        <div class="container-left"><span style="transform : translateY(60%)">
            Bourse aux jouets<br> 
            Edition 2022<br>
            <div style="font-size : 0.5em; line-height : 50px; font-style : italic;">
                Vous déposez.<br>
                Nous vendons.<br>
                Vous empochez.<br>
            </div>
        </span></div>
        <div class="container-left"><span style="transform : translateY(70%); display: flex; flex-direction : column;">
            <!--<div on:click={goRegister}  class="inscrire">S'inscrire</div>-->
            <div style="color: rgb(200,20,20); font-size:2rem; margin-bottom:3vh">/!\ Les inscriptions sont fermées /!\</div>
            <div on:click={goLogin} class="connecter" >Se connecter</div>
        </span></div>
    </div>
    <div class="maina">
        <h1 id="propos" style="font-size:4em; text-decoration : underline;">A propos</h1>
        <p>Association loi 1901, créée en 1983, dont le siège est à l’Hôtel de Ville du Perreux sur Marne</p>
        <p>Tous les membres sont bénévoles, aucun salarié : une centaine de bénévoles</p>
        <p>Objectif : organiser des manifestations ayant pour but d’alimenter un fonds de solidarité destiné à des Perreuxiens en difficulté, des plus jeunes aux aînés</p>
        
    </div>
    <div class="mainb">
        <h1 id="contact" style="font-size:4em; text-decoration : underline;">Nous contacter</h1>
        <p>Mail : ...@...</p>
        <p>Tel : xx xx xx xx xx</p>
        <p>Adresse : XXX</p>
    </div>
</main>





<style>

    main{
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: auto;
        background-color: #262626;
        align-items: center;
    }


    a{ 
        color: white;
        padding-left: 12px;
        padding-right: 12px;
        margin: 5px;
        border-radius: 10px ;
        font-weight: 700;
    }

    a:hover{
        color: #507DBC ;
        text-decoration: none;
    }

    .elm{ 
        color: white;
        padding-left: 12px;
        padding-right: 12px;
        margin: 5px;
        border-radius: 10px ;
        font-weight: 700;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }


    .main{
        
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: row;
    }

    .maina{
        width: 100vw;
        padding-left: 10vw;
        height: 80vh;
        display: flex;
        flex-direction: column;
        font-family: 'Poppins', sans-serif;
        background-color: white;
    }

    .mainb{   
        width: 100vw;
        padding-left: 10vw;
        height: 80vh;
        display: flex;
        flex-direction: column;
        font-family: 'Poppins', sans-serif;
        color : white;
    }

    .container-left{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 50vh;
        color: white;
        font-family: 'Poppins', sans-serif;
        font-weight: 800;
        font-size : 4em;
        letter-spacing: .05em;
    }

    .inscrire{
        width: 15vw;
        height: fit-content;
        border-radius: 15px;
        background-color: #507DBC;
        cursor: pointer;
        color: white;
        font-size: 2.5rem;
        margin: 10px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
    }

    .inscrire:hover{
        transform: scale(1.025);
    }

    .connecter{
        user-select: none;
        cursor: pointer;
        width: 15vw;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 2.3rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        border: 5px #507DBC solid  ;
        transition: ease-in-out .25s;
    }

    .connecter:hover{
        transform: scale(1.025);
    }



    @keyframes glow {
  0% {
    background: #507DBC;
  }
  25% {
    background: #6785af;
  }
  100% {
    background: #507DBC;
  }
}

</style>